import { z } from 'zod';

import {
  PurchaseReceiptFolioSequenceSnapshotSchema,
  PurchaseReceiptFolioSequenceStatusSchema,
} from './purchases.schema.js';
import type {
  GetPurchaseReceiptFolioSequenceRequest,
  GetPurchaseReceiptFolioSequenceResponse,
  UpdatePurchaseReceiptFolioSequenceRequest,
  UpdatePurchaseReceiptFolioSequenceResponse,
} from './purchases-receipt-folio-sequence.dto.js';

const reasonSchema = z.string().trim().min(1).max(500);
const displayPrefixSchema = z
  .string()
  .trim()
  .min(1)
  .max(24)
  .regex(/^[A-Za-z0-9/-]+$/);

export const GetPurchaseReceiptFolioSequenceRequestSchema: z.ZodType<GetPurchaseReceiptFolioSequenceRequest> =
  z.object({
    companyId: z.uuid(),
    locationId: z.uuid(),
  });

export const GetPurchaseReceiptFolioSequenceResponseSchema: z.ZodType<GetPurchaseReceiptFolioSequenceResponse> =
  z.object({
    sequence: PurchaseReceiptFolioSequenceSnapshotSchema.nullable(),
  });

export const UpdatePurchaseReceiptFolioSequenceRequestSchema: z.ZodType<UpdatePurchaseReceiptFolioSequenceRequest> =
  z.object({
    companyId: z.uuid(),
    storeId: z.uuid().nullable().optional(),
    locationId: z.uuid(),
    stationId: z.uuid().nullable().optional(),
    displayPrefix: displayPrefixSchema,
    padding: z.number().int().min(1).max(12),
    nextNumber: z.number().int().positive(),
    status: PurchaseReceiptFolioSequenceStatusSchema.optional(),
    version: z.number().int().min(1).nullable().optional(),
    reason: reasonSchema,
  });

export const UpdatePurchaseReceiptFolioSequenceResponseSchema: z.ZodType<UpdatePurchaseReceiptFolioSequenceResponse> =
  z.object({
    sequence: PurchaseReceiptFolioSequenceSnapshotSchema,
  });
